import { IconSquarePlus } from '@tabler/icons-react'
import styled from 'styled-components'

import { SWMSPPEDisplayBlock } from '../../types/blueprint'

import { useLocale } from '@/context/localeContext'
import { ppelist } from '@/modules/swms-builder/data/ppe'

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
`

const Box = styled.div`
  width: 100%;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colour.neutral.white};
  gap: 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

type Props = {
  block: SWMSPPEDisplayBlock
}

export const SwmsPpeDisplayBlock: React.FC<Props> = ({ block }) => {
  const { t } = useLocale()

  if (!block.value?.length) return <>N/A</>

  const matchedPpe = block.value
    ? ppelist(t).filter((h) => block.value.includes(h.label))
    : []

  const matchedPpeLabels = matchedPpe.map((h) => h.label)
  const extraPpe = block.value.filter((h) => !matchedPpeLabels.includes(h))

  return (
    <Grid>
      {matchedPpe.map(({ icon, label }) => (
        <Box key={label}>
          {icon}
          {label}
        </Box>
      ))}

      {extraPpe.map((extraPpe, index) => (
        <Box key={[extraPpe, index].join('-')}>
          <IconSquarePlus size={32} stroke="1" />
          {extraPpe}
        </Box>
      ))}
    </Grid>
  )
}
